"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.when = void 0;
/** returns value (or value of called user function) if test is true else undefined */
function when(test, value) {
    return test
        ? typeof value === 'function' ? value() : value
        : undefined;
}
exports.when = when;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2hlbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy93aGVuLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBLHNGQUFzRjtBQUN0RixTQUFnQixJQUFJLENBQUksSUFBYSxFQUFFLEtBQVE7SUFDM0MsT0FBTyxJQUFJO1FBQ1AsQ0FBQyxDQUFDLE9BQU8sS0FBSyxLQUFLLFVBQVUsQ0FBQyxDQUFDLENBQUMsS0FBSyxFQUFFLENBQUMsQ0FBQyxDQUFDLEtBQUs7UUFDL0MsQ0FBQyxDQUFDLFNBQVMsQ0FBQztBQUNwQixDQUFDO0FBSkQsb0JBSUMifQ==